function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.0827 3.35187C11.6208 2.92584 12.3844 2.92584 12.9225 3.35187L12.9255 3.3548L19.9255 8.79523H19.9265C20.2924 9.07908 20.5026 9.51219 20.5026 9.9798V9.98175L20.5505 22.2073H3.50262V9.97003C3.50262 9.51371 3.71178 9.07995 4.0788 8.79523H4.07977L11.0798 3.3548L11.0827 3.35187Z",
  fill: "black",
  stroke: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 8.25H10.5C10.09 8.25 9.75 7.91 9.75 7.5C9.75 7.09 10.09 6.75 10.5 6.75H13.5C13.91 6.75 14.25 7.09 14.25 7.5C14.25 7.91 13.91 8.25 13.5 8.25Z",
  fill: "#676767"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 11C16.33 11 17 11.67 17 12.5V21.25H22C22.41 21.25 22.75 21.58 22.75 22C22.75 22.41 22.41 22.75 22 22.75H12.6592C12.8675 22.5667 13 22.2993 13 22V21.9482C13.4766 21.8509 13.9184 21.6167 14.2676 21.2676C14.7364 20.7987 15 20.163 15 19.5C15 18.837 14.7364 18.2013 14.2676 17.7324C13.7987 17.2636 13.163 17 12.5 17H11.5C11.3674 17 11.2403 16.9473 11.1465 16.8535C11.0527 16.7597 11 16.6326 11 16.5C11 16.3674 11.0527 16.2403 11.1465 16.1465C11.2403 16.0527 11.3674 16 11.5 16H14C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H13C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V14.0508C10.5233 14.1481 10.0816 14.3832 9.73242 14.7324C9.26358 15.2013 9 15.837 9 16.5C9 17.163 9.26358 17.7987 9.73242 18.2676C10.2013 18.7364 10.837 19 11.5 19H12.5L12.5977 19.0098C12.6939 19.0289 12.7831 19.0761 12.8535 19.1465C12.9473 19.2403 13 19.3674 13 19.5C13 19.6326 12.9473 19.7597 12.8535 19.8535C12.7831 19.9239 12.6939 19.9711 12.5977 19.9902L12.5 20H10C9.44772 20 9 20.4477 9 21C9 21.5523 9.44772 22 10 22H11C11 22.2993 11.1325 22.5667 11.3408 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.58 1.59 21.25 2 21.25H7V12.5C7 11.67 7.67 11 8.5 11H15.5Z",
  fill: "#585858"
});

var SvgMarginLightActive = function SvgMarginLightActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarginLightActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Margin_light_active.df6f4df5.svg";
export { ForwardRef as ReactComponent };